/* eslint-disable */
import React, { Component } from 'react';
import {Grid, Header, Image, Label, Segment,Button,Icon,TextArea,Form, Popup, Message,Dropdown,Divider} from "semantic-ui-react";
import * as fileIcon from "../../assets/fileIcon.png";
import AddExpense from "../accounts/expense/add_expense";
import UpdateExpense from "../accounts/expense/update_expense";
import Loader from "../universal/loader";
import InspectionContainer from "../../containers/inspection_container";
import { getPropertyDetails } from "../../data/user_api";
import ViewPropertyDetails from "../properties/view_property_details"
import moment from 'moment-business-days';
import ChangeHistory from './change_history';

class ViewInspection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            action: "view",
            isFetching: true,
            addExpense:false,
            selectedInspection: undefined,
            showPropertyDetails: false,
            fetchingPropertyDetails : true,
            selectedEmailOption:"default",
            office365:false,
            showChangeHistory:false
        }
    }

    componentWillMount(){
        this.props.getInspectionDetailById(this.props.inspectionId);
    }

    getPropertyDetails = async () => {
        let propertyDetails = await getPropertyDetails(this.props.selectedInspection["id"])
        this.setState({propertyDetails: propertyDetails,fetchingPropertyDetails:false})
    }
    openMaps = (address) => {
        let full_link = "https://www.google.com/maps/dir/?api=1&destination=" + encodeURI(address)
        Object.assign(document.createElement('a'), { target: '_blank', href: full_link}).click()
    }
    openEmail = (mailto, cc, subject,selectedInspection) => {
     let body = ""
     let bcc = undefined
        switch (this.state.selectedEmailOption) {
            case "default":
                body = `
            Please find the inventory report attached.
            
            For report queries, please direct the recipients to the final page
            
            Thank you for choosing Hinch Property Management
            
            Kind regards,`
            subject = `Report for ${subject}`
            break;
              case "reportPCM":
                body = `
    
                Please find the inventory report attached.

                For questions and support related to the tenants' utilities and meter readings, please direct the recipients to the last page of the 'Meters' section of the report. 
                        
                For report queries, please direct the recipients to the final page.

                Thank you for choosing Hinch Property Management`
            subject = `Report for ${subject}`
            break;
            case "reportInvoice":
                body = `
        Please find the inventory report attached.
        
        For report queries, please direct the recipients to the final page
        
        Thank you for choosing Hinch Property Management
        
        Also attached is the invoice, please ensure this is with the correct recipient, this is due for payment within 30 days as per our Terms and Conditions.
        
        Kind regards,`
        subject = `Report and Invoice for ${subject}`
                break;
            case "cleaning":
                body = `
Please find the cleaning invoice attached.

Thank you for choosing Hinch Property Management

Kind regards,`
subject = `Cleaning Invoice for ${subject}`

                break;
            case "abort":
                body = `
Please find the abort invoice attached.

Thank you for choosing Hinch Property Management

Kind regards,`
subject = `Abort Invoice for ${subject}`
                break;
            case "alarm":
                body = `
Please find the alarm installation invoice attached.

Thank you for choosing Hinch Property Management

Kind regards,`
subject = `Alarm Installation Invoice for ${subject}`
                break;
            case "private":
                body = `
Good Day

Please find the Hinch PM invoice attached for prompt payment, we will require cleared funds before the inspection date for the inventory check to be carried out 

Please respond to this email once paid to confirm.

Thank you for choosing Hinch Property Management

Kind regards,`
subject = ` URGENT Payment required for ${subject}`
                break;
                case "privatechase":
                    body = `
Please note that our clerk has completed the report, and we are just awaiting payment on the invoice attached, before sending it through

If there are any queries, please let us know

Thank you for choosing Hinch Property Management

    Kind regards,`
    subject = `Invoice for ${subject}`
                    break;
                    case "confirmco":
                        body = `Hello
We are emailing on behalf of ${selectedInspection.company_name} regarding your upcoming check out booked on ${moment(selectedInspection.inspection_time.inspection_date).format("DD/MM/YYYY")}  at the above property.

We currently have this booked at ${selectedInspection.inspection_time.inspection_start_time}, where at this time one of our clerks will meet yourselves at the property for you to hand their keys over and they will proceed with the check out inspection.

Please reply to this email at your earliest convenience to confirm this time.

Please also find attached the check in document that was compiled when you moved into the property.  The check out report process is a direct comparison to this document.

Do let us know if you have any further questions.
`
        subject = `Confirming attendance for Check Out  ${subject} ${moment(selectedInspection.inspection_time.inspection_date).format("DD/MM/YYYY")} at ${selectedInspection.inspection_time.inspection_start_time}`
        mailto= undefined  
        cc=undefined             
        break;
                        case "confirmci":
                            body = `Hello,
                            
We are emailing on behalf of ${selectedInspection.company_name} regarding the upcoming check-in booked on ${moment(selectedInspection.inspection_time.inspection_date).format("DD/MM/YYYY")} at the above property.

We currently have this booked at ${selectedInspection.inspection_time.inspection_start_time}, where at this time one of our clerks will meet yourself at the property to hand the keys over.

Please reply to this email at your earliest convenience to confirm this time.

We look forward to hearing back from you.
`
            subject = `Confirming attendance for Inventory Check In ${subject} ${moment(selectedInspection.inspection_time.inspection_date).format("DD/MM/YYYY")} at${selectedInspection.inspection_time.inspection_start_time}`
            mailto= undefined   
            cc=undefined          
            break;
                case "gcp":
                    body = `
                Please find the inventory report attached.
                
                For report queries, please direct the recipients to the final page
                
                Thank you for choosing Hinch Property Management
                
                Kind regards,`
                subject = `Report for ${subject}`
                bcc = "lydia.walsh@grandcityproperty.co.uk; + RELEVANT PM (SEE MASTER DOC)"
                cc = undefined
                mailto= `To (tenants)`
                break;
                case "confirmcogcp":
                    body = `Hello
We are emailing on behalf of ${selectedInspection.company_name} regarding your upcoming check out booked on ${moment(selectedInspection.inspection_time.inspection_date).format("DD/MM/YYYY")}  at the above property.

We currently have this booked at ${selectedInspection.inspection_time.inspection_start_time}, where at this time one of our clerks will meet yourselves at the property for you to hand their keys over and they will proceed with the check out inspection.

Prior to meeting you, please do ensure all personal belongings have been removed and any cleaning you wish to do has been completed.

Kindly reply to this email at your earliest convenience to confirm this time.

Do let us know if you have any further questions.
`
    subject = `Confirming attendance for Check Out  ${subject} ${moment(selectedInspection.inspection_time.inspection_date).format("DD/MM/YYYY")} at ${selectedInspection.inspection_time.inspection_start_time}`
    mailto= undefined  
    cc=undefined             
    break;
            default:
                break;
        }
        if(!this.state.office365){
            window.open(`mailto:${mailto?encodeURIComponent(mailto):""}?subject=${encodeURIComponent(subject)}${cc?"&cc=" + encodeURIComponent(cc):""}${bcc?"&bcc=" + encodeURIComponent(bcc):""}&body=${encodeURIComponent(body)}`)
        } else {
            let targetUrl = `https://outlook.office.com/mail/deeplink/compose?to=${mailto}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
            window.open(targetUrl);
    }
}
    renderImages = (images) => {
        return images.map((image, i) => <Image key={i} as='a' target='_blank'
                                               href={image.file}
                                               src={image['content_type'] && image['content_type'].match(/image/i)? image.file:fileIcon}/>);
    };
    renderEmailPopup = (selectedInspection) =>{
        return <Popup wide="very"on={"click"} trigger={<Button icon compact><Icon name="envelope"/> Email</Button>}
       
        content={<div> 
            <Header as="h5">Email Client:</Header>
            <div style={{textAlign:"center"}} >
            <Button.Group style={{margin:"auto"}}>
                <Button compact  positive={this.state.office365 ? false:true} onClick={()=>{this.setState({office365:false})}}>Desktop Email</Button>
                <Button.Or />
                <Button compact  positive={this.state.office365 ? true:false}  onClick={()=>{this.setState({office365:true})}} >Office 365</Button>
            </Button.Group>
            </div>
            <Header as="h5">Template:</Header>
            <Dropdown value={this.state.selectedEmailOption} placeholder='Email Template' fluid selection options={[
                {key:"default",text:"Report Sending Default",value:"default"},
                {key:"reportPCM",text:"Report Sending w/ Please Connect Me",value:"reportPCM"},
                {key:"reportInvoice",text:"Report Sending w/ Invoice",value:"reportInvoice"},
                {key:"cleaning",text:"Cleaning",value:"cleaning"},
                {key:"abort",text:"Abort Invoice",value:"abort"},
                {key:"alarm",text:"Alarm Installation",value:"alarm"},
                {key:"private",text:"Private Invoice Standard",value:"private"},
                {key:"privatechase",text:"Private Invoice Chasing (Report Submitted)",value:"privatechase"},
                {key:"gcp",text:"GCP Report Sending",value:"gcp"},
                {key:"confirmci",text:"Confirming Tenant - CI",value:"confirmci"},
                {key:"confirmco",text:"Confirming Tenant - CO",value:"confirmco"},
                {key:"confirmcogcp",text:"Confirming Tenant GCP - CO",value:"confirmcogcp"}
            ]} onChange={(e,{value}) => this.setState({selectedEmailOption:value})}/>
            <Header as="h5">Addressee:</Header>
        <Button.Group><Button className="icon-button" compact onClick={() => { this.openEmail(selectedInspection["company_email_report"], selectedInspection["company_email_invoice"], `${selectedInspection["inspection_type"].toUpperCase()} ${ selectedInspection["property"].address}`, selectedInspection) }}><Icon name="mail"></Icon>Email Company</Button>
        <Button className="icon-button" compact disabled={!(selectedInspection["agent_profile_report_email"] || selectedInspection["agent_profile_invoice_email"])} onClick={() => { this.openEmail(selectedInspection["agent_profile_report_email"], selectedInspection["agent_profile_invoice_email"],  `${selectedInspection["inspection_type"].toUpperCase()} ${ selectedInspection["property"].address}`,selectedInspection) }}><Icon name="mail"></Icon>Email Agent</Button></Button.Group> </div>}>                       
        </Popup>
    }
    calcTimeDict = {
        "08:0018:00":"ANYTIME",
        "08:0017:00":"ANYTIME",
        "08:0012:00":"ANYTIME AM",
        "12:0018:00":"ANYTIME PM"
    }

    calcTime = (startTime,endTime) =>{
        let strTime = this.calcTimeDict[`${startTime}${endTime}`]
        if (strTime != undefined) {
            return strTime
        } else {
            return startTime
        }
    }
    render() {
        const selectedInspection = this.props.selectedInspection;
        const inspectionStatus = {"pending":'Pending', "scheduled":'Scheduled', "confirmed":'Confirmed', "processing":'Processing', "submitted":'Submitted', "completed":'Completed', "request_abort":'Requested Abort', "aborted":'Aborted', "request_cancel":'Request Cancel', "cancelled":'Cancelled'};
        const inspectionTypes = {"inv": "Inventory", "ci": "Check-In", "co": "Check-Out", "inv/ci": "Inventory/Check-In", "pv":"Property Visit","rev":"Revisit","cln":"Cleaning","sng":"Snagging List"};
        const furnTypes = {"unfurnished": "UN", "furnished": "F", "semifurnished": "PF"};
        const propertySize = ["Studio","1 Bedroom","2 Bedroom","3 Bedroom","4 Bedroom","5 Bedroom","6 Bedroom","7 Bedroom","8 & Above Bedrooms"];
        const copyTableToClipboard = () => {  
            let tableHtml = `<table><tr>
            <td>${moment(selectedInspection.inspection_time.inspection_date).format("DD/MM/YYYY")}</td>
            <td>${selectedInspection.company_name}</td>
            <td></td>
            <td>${selectedInspection.property.address}</td>
            <td>${selectedInspection.inspection_type.toUpperCase()}</td>
            <td>${selectedInspection.property.property_size == 0 ? "ST" : `${selectedInspection.property.property_size}B` }${furnTypes[selectedInspection.property.furnishing_type]}</td>
            <td>${selectedInspection.invoice_charge}</td>
            <td>${selectedInspection.reference_id}</td>

            </tr></table>`
            const blob = new Blob([tableHtml], { type: 'text/html' });
            const clipboardItem = new ClipboardItem({ 'text/html': blob });
        
            // Copy to clipboard
            navigator.clipboard.write([clipboardItem])


         }
        const copyToClipboard = () => {
            navigator.clipboard.writeText(
    `
Property Address: ${selectedInspection.property.address}
Inspection Type: ${inspectionTypes[selectedInspection.inspection_type]}
Inspection Date: ${moment(selectedInspection.inspection_time.inspection_date).format("DD/MM/YYYY")}
Inspection Start Time: ${selectedInspection.inspection_time.inspection_start_time}
Furnishing Type: ${selectedInspection.furnishing_type}
Property Size: ${propertySize[selectedInspection.property.property_size]}
Key Collected From: ${selectedInspection.get_keys_from}
Keys Returned To: ${selectedInspection.return_keys_to}
Company Name: ${selectedInspection.company_name}
Tenant Name: ${selectedInspection.tenant_name}
Tenant Contact: ${selectedInspection.tenant_contact}

Notes:

${selectedInspection.notes}`)
        }
        const timeExplanation = <div>
            <Segment><strong>Inventory Check Ins, Check Ins:</strong><br/>The clerk will arrive around 1 hour before the start time to conduct the inventory, the start time is when the clerk will be ready to meet the tenants for check in. The tenants should arrive at start time to meet the clerk</Segment>
            <Segment><strong>Inventory Only (No Tenants):</strong><br/>The start time is when the clerk will arrive at the property to carry out the inventory.</Segment>
            <Segment><strong>Check Outs:</strong><br />The start time is when the clerk will arrive at property to start the check out, if tenants are present, they should be ready to receive the clerk at the start time</Segment>
        </div>
        return (
            <div>
                <Header size="large"  textAlign="center">Inspection Details {this.props.currentUserRole === 'admin' && <span className="icon-button" onClick={()=>{this.props.currentUserRole === 'admin' ?this.props.handleEdit(selectedInspection.id):null}}> <Icon name="write" size="small" color="blue"  /></span>}
                    {this.props.currentUserRole === 'admin' && this.props.selectedInspection && <span>
                    <Popup trigger={<Button compact  icon><Icon name="settings" />Tools</Button>} on="click" position="bottom left" content={<div style={{ display:"flex", flexDirection:"column", gap:"0.5rem" }}>
                        <Button className="icon-button" compact onClick={copyToClipboard}><Icon name="copy" />Copy</Button>
                        <Button className="icon-button" compact onClick={copyTableToClipboard}><Icon name="copy" />SDB Copy</Button>
                        <Button className="icon-button" compact onClick={() => selectedInspection.online_viewer_link && window.open(selectedInspection.online_viewer_link, "_blank")}><Icon name="external alternate" />Report Viewer</Button>
                        </div>} />
                        {this.renderEmailPopup(selectedInspection)}
                        {this.props.selectedInspection["date_submitted"] ? <Popup wide="very" trigger={<Button compact> Date Submitted</Button>}>Date First Submitted: {moment(this.props.selectedInspection["date_submitted"],"YYYY-MM-DD HH:mm").format("HH:mm [on] DD-MM-YYYY")}</Popup> : null}
                    </span>}
                    {this.props.selectedInspection && <Button className="icon-button" compact onClick={() => { this.openMaps(selectedInspection["property"].address) }}><Icon name="map"></Icon>Directions</Button>}
                    {this.props.currentUserRole !== "agent" && this.props.selectedInspection && ((this.props.currentUserRole === "admin" && this.props.selectedInspection["booking_requirements"]) ||this.props.selectedInspection["report_requirements"]) && <span>
                        <Popup wide='very' trigger={<Button className="icon-button" compact><Icon name="list"></Icon>Requirements</Button>}>
                        <Message header="Report Requirements" content={this.props.selectedInspection["report_requirements"]?this.props.selectedInspection["report_requirements"].split("\n").map((value, index) => {return (<React.Fragment key={index}>{value}<br /></React.Fragment>);}):"None"}></Message>
                        {this.props.currentUserRole === "admin" && <Message header="Booking Requirements" content={this.props.selectedInspection["booking_requirements"]?this.props.selectedInspection["booking_requirements"].split("\n").map((value, index) => {return (<React.Fragment key={index}>{value}<br /></React.Fragment>);}):"None"}></Message>}
                    </Popup>
                    </span>}
                    {this.props.currentUserRole !== "agent" && this.props.selectedInspection && ((this.props.selectedInspection["agent_telephone"]) ||this.props.selectedInspection["company_telephone"]) && <span>
                        <Popup on='click' wide='very' trigger={<Button color="orange" className="icon-button" compact><Icon name="list"></Icon>Phone Numbers</Button>}>
                            <Message header="Company Number" content={this.props.selectedInspection["company_telephone"] ? <span>{this.props.selectedInspection["company_telephone"]} <a href={`tel:${this.props.selectedInspection["company_telephone"]}`}><Button compact basic color="orange" icon><Icon name="call"/>Call</Button></a></span>:"None"}></Message>
                            <Message header="Branch/Agent Number" content={this.props.selectedInspection["agent_telephone"] ? <span>{this.props.selectedInspection["agent_telephone"]} <a href={`tel:${this.props.selectedInspection["agent_telephone"]}`}><Button compact basic color="orange" icon><Icon name="call"/>Call</Button></a></span>:"None"}></Message>
                    </Popup>
                    </span>} 
                </Header>
                { this.props.isDetailsFetching || (selectedInspection && selectedInspection.length == 0) ? <Loader contain={true}/> : <div>
                {!this.state.addExpense && selectedInspection && <Segment>
                    <div className="column twelve">
                        <div className="pad-bottom">
                            <Grid columns={3} className="minTop-margin">
                                <Grid.Row style={{fontSize: '1.2em', textAlign: 'center'}}>
                                    <Grid.Column>
                                        <div><span
                                            className="format-bold">Reference Id: </span><span>{selectedInspection['reference_id']?selectedInspection['reference_id']:"NA"}</span>
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <div><span
                                            className="format-bold">Assigned To: </span>{selectedInspection.user ?
                                            <span>{selectedInspection.user.name}</span> :
                                            <span style={{color: "red"}}>Un Assigned</span>}</div>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <div>
                                            <span className="format-bold">Status: </span>
                                            <span>{inspectionStatus[selectedInspection['status']]}</span></div>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </div>
                    </div>

                    <Grid stackable columns={2} className="minTop-margin left-aligned" style={{marginTop: '0.5em'}}>
                        <Grid.Row>
                            <Grid.Column>
                                <Segment  style={{height: '100%'}}>
                                    <Label color='blue' ribbon>
                                        Property Details
                                    </Label>
                                    <p></p>
                                    <Grid.Column>
                                        <dl>
                                            <dt>Company Name</dt>
                                            <dd>{selectedInspection['company_name']}</dd>

                                            <dt>Agent Name</dt>
                                            <dd>{selectedInspection['agent_profile_name']}</dd>

                                            <dt>Property Size</dt>
                                            <dd>{propertySize[selectedInspection['property_size'] === '8 & Above'? 8:selectedInspection['property_size'] !== 'studio'?selectedInspection['property_size']:0]}</dd>

                                            <dt>Furnishing Type</dt>
                                            <dd className="format-capitalize">{selectedInspection['furnishing_type'] === 'semifurnished'?"Part-Furnished":selectedInspection['furnishing_type']}</dd>

                                            <dt style={{height: '60px'}}>Address</dt>
                                            <dd>{selectedInspection.property['address']}
                                            </dd>
                                        </dl>
                                    </Grid.Column>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column className="left-aligned">
                                <Segment  style={{height: '100%'}}>
                                    <Label color='blue' ribbon>
                                        Inspection Details
                                    </Label>
                                    <p></p>
                                    <Grid.Column>
                                        <dl>
                                            <dt>Inspection Type</dt>
                                            <dd>{inspectionTypes[selectedInspection['inspection_type']]}</dd>

                                            <dt>Inspection Date</dt>
                                            <dd>{moment(selectedInspection['inspection_start_time'],"YYYY-MM-DD HH:mm").format("DD-MM-YYYY")}</dd>

                                            <dt>Inspection Start Time</dt>
                                            <dd>{this.calcTime(moment(selectedInspection['inspection_start_time'], "YYYY-MM-DD HH:mm Z").format("HH:mm"),moment(selectedInspection['inspection_end_time'], "YYYY-MM-DD HH:mm Z").format("HH:mm"))}</dd>
                                            {/* <dd>{moment(selectedInspection['inspection_start_time'],"YYYY-MM-DD HH:mm").format("HH:mm")}</dd> */}

                                            {/* <dt>Inspection End Time</dt>
                                            <dd>{moment(selectedInspection['inspection_end_time'],"YYYY-MM-DD HH:mm").format("HH:mm")}</dd> */}
                                        </dl>
                                        <div className="center-aligned">
                                                <Popup wide="very" trigger={<Button icon labelPosition='right'>How To Interpret Start Times<Icon name="question"></Icon></Button>}>{timeExplanation}</Popup>
                                            {/* {(selectedInspection['pipeline_expenses'] && (selectedInspection['pipeline_expenses']['status'] !== 'approved' || selectedInspection['pipeline_expenses']['status'] !== 'paid' || selectedInspection['pipeline_expenses']['status'] !== 'processed' ))? <Button onClick={() => {this.setState({addExpense:true})}} content="Update Expense" color="orange"/> : ((selectedInspection['pipeline_expense'] && selectedInspection['pipeline_expense']['status'])?<span className="info-normal format-bold">Expense Already Processed</span> :<Button onClick={() => {this.setState({addExpense:true})}} content="Add Expense" color="orange"/>)} */}
                                        </div>
                                        <Divider></Divider>
                                        <dl>
                                        <dt>Report Due Date</dt>
                                            <dd>{moment(selectedInspection['inspection_start_time'], "YYYY-MM-DD HH:mm Z").businessAdd(selectedInspection['priority_tat']?1:2).format("DD-MM-YYYY")}</dd>
                                        </dl>
                                    </Grid.Column>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Segment  style={{height: '100%'}}>
                                    <Label color='blue' ribbon>
                                        Additional Details
                                    </Label>
                                    <p></p>
                                    <Grid.Column>
                                        <dl>
                                            <dt>Tenant Name</dt>
                                            <dd>{selectedInspection['tenant_name']?selectedInspection['tenant_name']:"NA"}</dd>

                                            <dt>Tenant Contact</dt>
                                            <dd>{selectedInspection['tenant_contact']?selectedInspection['tenant_contact']:"NA"}</dd>

                                            <dt>Get keys From</dt>
                                            <dd>{selectedInspection['get_keys_from']?selectedInspection['get_keys_from']:"NA"}</dd>

                                            <dt>Return Keys To</dt>
                                            <dd>{selectedInspection['return_keys_to']?selectedInspection['return_keys_to']:"NA"}</dd>

                                            <dt>Report Type</dt>
                                            <dd className="format-capitalize">{selectedInspection['report_type'] ? selectedInspection['report_type'] : "NA"}</dd>
                                            </dl>
                                            {selectedInspection['property']['property_notes'] && <Form>
                                                <label className="format-bold pad-bottom">
                                                    Property Notes
                                                </label>
                                                <TextArea autoHeight value={selectedInspection['property']['property_notes'] ? selectedInspection['property']['property_notes'] : ""} readOnly />
                                            </Form>}
                                    </Grid.Column>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column className="left-aligned">
                                <Segment  style={{height: '100%'}}>
                                    <Label color='blue' ribbon>
                                        Invoice Details
                                    </Label>
                                    <p></p>
                                    <Grid.Column>
                                            <dl>
                                                {this.props.currentUserRole != 'agent' && <React.Fragment>
                                                    <dt>Clerk Pay/Extra Amount</dt>
                                                    <dd>{selectedInspection['clerk_charge'] ? selectedInspection['clerk_charge'] : "NA"}</dd>
                                                    {this.props.currentUserRole == "admin" && <React.Fragment><dt>Invoice Price/Extra Amount</dt>
                                                        <dd>{selectedInspection['invoice_charge'] ? selectedInspection['invoice_charge'] : "NA"}</dd></React.Fragment>}
                                                </React.Fragment>}
                                            <dt>Send Invoice To</dt>
                                            <dd>{selectedInspection['send_invoice_to']?selectedInspection['send_invoice_to']:"NA"}</dd>
                                            <dt>Send Report To</dt>
                                            <dd>{selectedInspection['send_report_to']?selectedInspection['send_report_to']:"NA"}</dd>
                                        </dl>
                                    </Grid.Column>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>
                        {this.props.currentUserRole === 'admin' ? <Grid.Row>
                            <Grid.Column>
                                <Segment style={{height: '100%'}}>
                                    <Form>
                                        <label className="format-bold">
                                            Inspection Notes
                                        </label>
                                    <TextArea autoHeight rows={4} value={selectedInspection['notes'] ? selectedInspection['notes'] : ""}
                                                   readOnly />
                                    </Form>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column>
                                <Segment style={{height: '100%'}}>
                                    <Form>
                                        <label className="format-bold pad-bottom">
                                            Inspection Conclusion Notes
                                        </label>
                                   <TextArea autoHeight rows={4} value={selectedInspection['conclusion_notes'] ? selectedInspection['conclusion_notes'] : ""}
                                              readOnly/>
                                    </Form>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>:<Grid.Row>
                            <Grid.Column width={16}>
                                <Segment style={{height: '100%'}}>
                                    <Form>
                                        <label className="format-bold pad-bottom">
                                            Inspection Notes
                                        </label>
                                        <TextArea autoHeight rows={4} value={selectedInspection['notes'] ? selectedInspection['notes'] : ""}
                                                  readOnly />
                                    </Form>
                                </Segment>
                            </Grid.Column>
                        </Grid.Row> }
                    </Grid>
                    <div style={{paddingTop: '2%'}}>
                        <Segment  className="left-aligned">
                            <Label color='blue' ribbon>
                                Inspection Attachments
                            </Label>
                            <p></p>
                            <div className="center-aligned" style={{minHeight: '50px'}}>
                                {selectedInspection['inspection_attachments'].length > 0 ? <Image.Group size='small'>
                                        {this.renderImages(selectedInspection['inspection_attachments'])}
                                    </Image.Group> :
                                    <h4 style={{color: 'rgb(152, 152, 152)'}}>No Attachments Available</h4>}
                            </div>
                        </Segment>
                    </div>
                </Segment> }
                {!this.state.addExpense && <Segment >  {!this.state.showPropertyDetails ? <div style={{textAlign:"center"}}><Button primary  icon="home" content="Show Property Details" onClick={() => { this.setState({ showPropertyDetails: true }); this.getPropertyDetails() }}/></div> : this.state.fetchingPropertyDetails ? <Button loading > Loading </Button> : <ViewPropertyDetails userRole={this.props.currentUserRole} disableMerge={true} selectedObject={[this.state.propertyDetails]}/>} {this.props.currentUserRole == "admin" && <div><Divider/> {this.state.showChangeHistory ? <ChangeHistory changeHistory={selectedInspection["change_history"]}></ChangeHistory> :  
                <div style={{textAlign:"center"}}><Button primary content="Show Change History" icon="list" onClick={() => { this.setState({ showChangeHistory: true })}}/></div>}</div>}</Segment>}
               
                {this.state.addExpense && <Segment>{selectedInspection['pipeline_expense'] && selectedInspection['pipeline_expense']['id'] ? <UpdateExpense inspectionId={selectedInspection['id']} userId={selectedInspection['user_id']} goBack={() =>{this.setState({addExpense:false})}}  expenseUpdates={selectedInspection['pipeline_expense']}/> : <AddExpense inspectionId={selectedInspection['id']} userId={selectedInspection['user_id']} goBack={() =>{this.setState({addExpense:false})}} /> }</Segment>}
                    </div>}
                </div>
        );
    }

}

export default InspectionContainer(ViewInspection);


// WEBPACK FOOTER //
// ./src/views/inspection/view_inspection_details.js